export default __webpack_public_path__ + "static/media/img7.21fed51d.PNG";